




















































































































































































































































































































































































































































import { ValidationObserver, ValidationProvider } from "vee-validate";
import { Component, Ref, Vue } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import {
  CustomerModel,
  CustomersApi,
  LocationModel,
  LocationsApi,
  UserModel,
} from "../../../apis";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import AddLocationNewCustomer from "./AddLocationNewCustomer.vue";
import { ACTION, ILocation } from "./index";

@Component({
  components: {
    AddLocationNewCustomer,
    MoreVertBtn,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class AdminCustomerDetail extends Vue {
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  @Ref("observerNewLocation") readonly observerNewLocation!: InstanceType<
    typeof ValidationObserver
  >;
  @Ref("observerEditLocation") readonly observerEditLocation!: InstanceType<
    typeof ValidationObserver
  >;

  customerDetail: CustomerModel | any = {};
  locations: LocationModel[] = [];
  selectedLocation: LocationModel = null;
  mode = "";
  showDisableDialog = false;
  showDisconnectDialog = false;
  showLocationDialog = false;
  showEditAddrForm = false;
  editLocation: ILocation = {};
  backupEditLocation: ILocation = {};

  created() {
    this.getData();
  }

  onEditAddress(item) {
    this.editLocation = item;
    this.backupEditLocation = JSON.parse(
      JSON.stringify(this.editLocation)
    ) as ILocation;
    this.showEditAddrForm = true;
  }

  mounted() {
    const btn = document.querySelector(
      ".button-customer-edit-save"
    ) as HTMLButtonElement;
    if (btn) {
      btn.onclick = () => {
        this.$util.showLoading();
        new CustomersApi()
          .updateCustomer({
            id: this.customerDetail.id,
            putCustomerRequest: {
              ...Object.assign({}, this.customerDetail, {
                createdBy: undefined,
                updatedBy: undefined,
              }),
              locations: this.locations,
            },
          })
          .then(() => {
            this.$util.hideLoading();
            this.$router.push({
              name: "customer-detail",
              params: { id: this.customerDetail.id },
              query: { t: "" + new Date().getTime() },
            });
          })
          .catch((error) => {
            this.$util.hideLoading();
            this.$util.showError(error);
          });
      };
    }
  }

  get itemsStatus() {
    return [
      { value: "Active", text: this.$t("locationColumn.status.Active") },
      { value: "Inactive", text: this.$t("locationColumn.status.Inactive") },
    ];
  }

  get COUNTRIES() {
    return this.$util.getConfig().settings.country;
  }

  locationOption: Array<ILocation> = [];

  get locationOptionBuilder() {
    const newOptions = this.locationOption.map((opt, index) => {
      return {
        ...opt,
        text: `${opt.address}, ${opt.country}`,
        value: index,
      };
    });
    newOptions.push({
      country: "",
      address: "",
      isPrimary: false,
      text: `+ Add New Address`,
      value: -1,
    });
    return newOptions;
  }

  locationOptionSelected = {};

  get ACTIONS(): IAction[] {
    return [
      {
        titleName: this.$t("text.edit"),
        action: ACTION.EDIT,
        permission: { context: "LOCATION_MANAGEMENT", action: "update" },
      },
      {
        titleName: this.$t("text.disable"),
        action: ACTION.DISABLE,
        titleStyle: "color: red",
        permission: {
          context: "LOCATION_MANAGEMENT|ACTIVATE_DEACTIVATE",
          action: "update",
        },
      },
      {
        titleName: this.$t("text.disconnect"),
        action: ACTION.DISCONNECT,
        titleStyle: "color: red",
        permission: {
          context: "LOCATION_MANAGEMENT|ACTIVATE_DEACTIVATE",
          action: "update",
        },
      },
      {
        titleName: this.$t("text.enable"),
        action: ACTION.ENABLE,
        titleStyle: "color: green",
        permission: {
          context: "LOCATION_MANAGEMENT|ACTIVATE_DEACTIVATE",
          action: "update",
        },
      },
    ];
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  get me() {
    return this.$store.getters.user as UserModel;
  }

  get HEADERS() {
    if (this.me.organization === "CLIENT") {
      return [
        {
          text: this.$t("locationColumn.locationName"),
          align: "start",
          value: "locationName",
          class: ["tw-p-4"],
        },
        {
          class: ["tw-p-4"],
          text: this.$t("locationColumn.address"),
          value: "address",
        },
        {
          class: ["tw-p-4"],
          text: this.$t("locationColumn.contact"),
          value: "contact",
          cellClass: ["tw-whitespace-pre"],
        },
        { class: ["tw-p-4"], text: this.$t("text.status"), value: "status" },
      ] as DataTableHeader[];
    }
    return [
      {
        class: ["tw-p-4"],
        text: this.$t("locationColumn.locationName"),
        align: "start",
        value: "locationName",
      },
      {
        class: ["tw-p-4"],
        text: this.$t("locationColumn.address"),
        value: "address",
      },
      {
        class: ["tw-p-4"],
        text: this.$t("locationColumn.contact"),
        value: "contact",
        cellClass: ["tw-whitespace-pre"],
      },
      { class: ["tw-p-4"], text: this.$t("text.status"), value: "status" },
      {
        class: ["tw-p-4"],
        text: this.$t("locationColumn.action"),
        value: "action",
      },
    ];
  }

  checkStatusAction(status: string, isOnline: boolean) {
    let listActions = this.ACTIONS;
    if (status == "Inactive") {
      listActions = this.ACTIONS.filter((val) => val.action != ACTION.DISABLE);
    } else {
      listActions = this.ACTIONS.filter((val) => val.action != ACTION.ENABLE);
    }
    if (!isOnline) {
      listActions = listActions.filter(
        (val) => val.action != ACTION.DISCONNECT
      );
    }
    return listActions;
  }

  onSelectedAction({ item, action }: { item: LocationModel; action: string }) {
    this.selectedLocation = item;
    if (action === ACTION.EDIT) {
      this.mode = "EDIT";
      this.showLocationDialog = true;
    }
    if (action === ACTION.DISABLE) {
      if (this.$route.name == "customer-edit") {
        this.selectedLocation.status = "Inactive";
      } else this.showDisableDialog = true;
    }
    if (action === ACTION.DISCONNECT) {
      if (this.$route.name == "customer-edit") {
        this.selectedLocation.status = "Active";
      } else this.showDisconnectDialog = true;
    }
    if (action === ACTION.ENABLE) {
      if (this.$route.name == "customer-edit") {
        this.selectedLocation.status = "Active";
      } else this.onDisableEnableLocation("Active");
    }
  }

  getData() {
    this.$util.showLoading();
    new CustomersApi()
      .getCustomerById({
        id: this.$route.params.id,
      })
      .then((response) => {
        this.customerDetail = response.data.data;
        this.customerDetail.freeTimes = this.customerDetail.freeTimes
          ? this.customerDetail.freeTimes
          : 0;
        this.locationOption = this.customerDetail.fullAddress;
        this.setLocationOptionSelected();
        this.$util.hideLoading();
      });

    new CustomersApi()
      .getLocationsByCustomerId({
        id: this.$route.params.id,
      })
      .then((response) => {
        this.locations = response.data.data;
      });
  }

  async onDisableEnableLocation(val?: string) {
    if (!this.selectedLocation) {
      return;
    }

    this.$util.showLoading();
    try {
      if (val) {
        await new LocationsApi().enableLocation({
          id: this.selectedLocation.id,
        });
      } else {
        await new LocationsApi().disableLocation({
          id: this.selectedLocation.id,
        });
      }
      this.showDisableDialog = false;
      const rs = await new CustomersApi().getLocationsByCustomerId({
        id: this.$route.params.id,
      });
      this.locations = rs.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
  async onDisconnectLocation(val?: string) {
    if (!this.selectedLocation) {
      return;
    }

    this.$util.showLoading();
    try {
      await new LocationsApi().disableLocation({
        id: this.selectedLocation.id,
        reActive: true,
      });
      this.showDisconnectDialog = false;
      const rs = await new CustomersApi().getLocationsByCustomerId({
        id: this.$route.params.id,
      });
      this.locations = rs.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onChangeCountry() {
    if ((this.locationOptionSelected as number) === -1) {
      this.newLocation = {};
      this.showAddAddrForm = true;
    } else {
      this.locationOption.map((opt) => (opt.isPrimary = false));
      const selectedOpt = this.locationOption.find(
        (opt, idx) => idx === this.locationOptionSelected
      );
      selectedOpt.isPrimary = true;
    }
  }

  showAddAddrForm = false;
  newLocation: ILocation = {};
  async onSubmitAddAdrForm() {
    const isValid = await this.observerNewLocation.validate();
    if (!isValid) return;
    this.locationOption.push({ ...this.newLocation, isPrimary: false });
    this.doHideAddAddrForm();
  }

  onCancelAddAdrForm() {
    this.doHideAddAddrForm();
  }

  doHideAddAddrForm() {
    this.showAddAddrForm = false;
    this.newLocation = {};
    this.setLocationOptionSelected();
  }

  async onSubmitEditAdrForm() {
    const isValid = await this.observerEditLocation.validate();
    if (!isValid) return;
    this.locationOption.forEach((location) => {
      if (
        location.address === this.backupEditLocation.address &&
        location.country === this.backupEditLocation.country
      ) {
        location.address = this.editLocation.address;
        location.country = this.editLocation.country;
        location.isPrimary = this.editLocation.isPrimary;
      }
    });
    this.doHideEditAddrForm();
  }

  onCancelEditAdrForm() {
    this.doHideEditAddrForm();
  }

  doHideEditAddrForm() {
    this.showEditAddrForm = false;
    this.editLocation = {};
    this.setLocationOptionSelected();
  }

  setLocationOptionSelected() {
    this.locationOptionSelected = this.locationOptionBuilder.find(
      (opt) => opt.isPrimary === true
    );
  }
}
